import { graphql } from "gatsby";
import Caption from "../../../../src/components/caption";
import * as React from 'react';
export default {
  graphql,
  Caption,
  React
};